import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';

type Props = {
    onPrimaryCtaClick: () => void;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='Save time with Campaign templates'
            subtitle='Create and publish reusable templates for your entire team'
            detailTextBullets={[
                'Templates published to your library will be available to all users',
                'To create a template, use an already sent or drafted broadcast, or start from scratch',
                'Unpublish or archive templates to make them no longer usable by your team',
            ]}
            cta={
                <Button variant='primary' size='big' onClick={props.onPrimaryCtaClick}>
                    Create new template
                </Button>
            }
            icon={
                <img
                    alt=''
                    style={{width: 160, paddingRight: 40}}
                    src='/include/images/empty-states/broadcast.svg'
                />
            }
        />
    );
}
